import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultLayout from 'admin/components/DefaultLayout';
import { useIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import Notifications from 'admin/components/Notifications';
import DrawerNotificationPreferences from 'ui/Drawer/Drawers/DrawerNotificationPreferences';
import { StyledMobileHeaderWrapper } from 'admin/components/MobileLayout/style';
import { StyledNotificationsMobileHeader } from './style';
import { adminPath } from 'enums/adminRoutes';

const NotificationsPage = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [reload, setReload] = useState(0);
  const [prefsOpen, setPrefsOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const openPrefs = () => setPrefsOpen(true);
  const closePrefs = () => setPrefsOpen(false);

  const handleOpenChat = (recipientFarmId: number) => {
    navigate(`${adminPath.chat()}?recipientid=${recipientFarmId}`);
  };

  return (
    <>
      <StyledNotificationsMobileHeader>
        <StyledMobileHeaderWrapper>
          <div className="mobile-header-item-wrapper">
            <Button
              type="text"
              label={intl.formatMessage({ id: 'notifications.open_settings' })}
              onClick={openPrefs}
              icon={
                <img
                  src="/svgs/admin/default-admin-icon.svg"
                  width={24}
                  height={24}
                  alt=""
                  className="admin-header-item-icon mobile-header-settings-icon"
                />
              }
            />
            <Button
              type="text"
              label={intl.formatMessage({ id: 'general.filter' })}
              onClick={() => setIsMobileFilterOpen(true)}
              icon={
                <Icon
                  name="admin-filter-icon"
                  className="admin-header-item-icon"
                />
              }
            />
          </div>
        </StyledMobileHeaderWrapper>
      </StyledNotificationsMobileHeader>
      <DefaultLayout.PageLayout
        breadcrumbs={[
          {
            title: intl.formatMessage({ id: 'navigation.beginning' }),
            href: '/',
          },
          {
            title: intl.formatMessage({
              id: 'navigation.notifications',
            }),
          },
        ]}
      >
        <DefaultLayout.PageContent>
          <Notifications
            reload={reload}
            onOpenChat={handleOpenChat}
            onOpenSettings={openPrefs}
            isMobileFilterOpen={isMobileFilterOpen}
            onMobileFilterOpenChange={setIsMobileFilterOpen}
          />
        </DefaultLayout.PageContent>

        <DrawerNotificationPreferences
          open={prefsOpen}
          onClose={closePrefs}
          onSaved={() => {
            setReload((n) => n + 1);
            closePrefs();
          }}
        />
      </DefaultLayout.PageLayout>
    </>
  );
};

export default NotificationsPage;
